import BFLLink from "@repo/shared-ui/BFLLink";

interface CorporateLink {
  linkTitle: string;
  linkUrl: string;
}
interface OurCompaniesProps {
  corporateLinksTitle: string;
  corporateLinks: CorporateLink[];
}
const OurCompanies = ({
  corporateLinksTitle,
  corporateLinks,
}: OurCompaniesProps) => {
  return (
    <div className="flex w-[40%] cursor-pointer flex-col md:w-[18%]">
      <h3 className="text-sm font-medium">{corporateLinksTitle}</h3>
      {corporateLinks?.map((link, index) => (
        <BFLLink
          key={"corpLink-" + index}
          href={link.linkUrl}
          className="mt-[8px] text-wrap text-[10px]"
        >
          {link.linkTitle}
        </BFLLink>
      ))}
    </div>
  );
};
export default OurCompanies;
